import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../../styles'
import { Checkbox, CheckboxProps } from '../Checkbox'
import { Field } from './Field'
import { FieldStatus } from './FieldStatus'

export type CheckboxFieldProps = {
    label?: React.ReactNode
    description?: string
    error?: React.ReactNode
    success?: React.ReactNode
} & CheckboxProps

function CheckboxFieldComponent({
    id = String(Math.random()),
    className,
    label,
    description,
    error,
    success,
    ...props
}: CheckboxFieldProps): React.ReactElement<CheckboxFieldProps> {
    return (
        <CheckboxFieldWrapper
            className={className}
            label={label}
            htmlFor={id}
            description={description}
        >
            <Checkbox {...props} id={id} />
            {(error || success) && <FieldStatus error={error} success={success} />}
        </CheckboxFieldWrapper>
    )
}
export const CheckboxField = styled(CheckboxFieldComponent)``

// TODO: there seems to be some specific styling for the filter content-list here, maybe move it there ?
export const CheckboxFieldWrapper = styled(Field)`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    ${S.form.field.ActualLabel} {
        cursor: pointer;
        padding: 15px 0;
        flex: 1;
    }
`
